import { QuotationDetails } from 'src/app/types/quotation.type';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from 'src/app/http.service';
import { NcacheSubscription } from 'src/app/models/ncache-subscription.model';
import { environment } from 'src/environments/environment';
import { SelfBuyForm } from '../interfaces/selfBuyForm.interface';
import { EnvironmentFormRequest } from '../interfaces/environment-form-request.interface';
import Helper from 'src/app/Util/helper';
import { delay } from 'rxjs/operators';
import { QuotationOtp } from '../interfaces/quotation-otp.interface';
import { ConfigureEnvironment } from '../interfaces/configure-environment.interaface';
import { QuotationType } from 'src/app/enums/quotation.enum';
import { QuotationEnvironmentsModel } from 'ncache-common-library';

@Injectable({
  providedIn: 'root'
})

export class QuotationService {

  constructor(private readonly http: HttpService) { }

  saveQuotationInfo(){
    
  }

  getInvoice(invoiceId: string, subscriptionId: string) {
    return this.http.get(environment.api.routes.subscription.paid.invoice, {
      subscriptionId,
      invoiceId
    });
  }

  checkInvoice(invoiceId: string, subscriptionId: string) {
    return this.http.get(environment.api.routes.subscription.paid.is_invoice_pending, {
      subscriptionId,
      invoiceId
    });
  }

  getCompletedInvoice(invoiceId: string, subscriptionId: string) {
    return this.http.get(environment.api.routes.subscription.paid.completedInvoice, {
      subscriptionId,
      invoiceId
    });
  }

  acceptInvoice(invoiceId: string, subscriptionId: string) {
    return this.http.get(environment.api.routes.subscription.paid.accept_invoice, {
      subscriptionId,
      invoiceId
    });
  }

  getSubscription(subscriptionUid: string): Observable<NcacheSubscription> {
    return this.http.get<NcacheSubscription>(environment.api.routes.subscription.get_subscription_by_uid, { subscriptionUID: subscriptionUid });
  }

  alreadyHasSelfBuyRequest(subscriptionId: string): Observable<boolean> {
    return this.http.get(environment.api.routes.subscription.paid.has_self_buy, { subscriptionId });
  }

  getQuotationEnvironments(quotationId: string): Observable<EnvironmentFormRequest[]> {
    const envs: EnvironmentFormRequest[] =  [
      Helper.generateGenericEnvironmentObject("ENVVVVVV-1", "production", "azure", "windows", "eastus", "Standard_B2ms", 3),
      Helper.generateGenericEnvironmentObject("ENVVVVVV-2", "test", "azure", "linux", "eastus", "Standard_B2ms", 2),
      Helper.generateGenericEnvironmentObject("ENVVVVVV-3", "staging", "azure", "windows", "eastus", "Standard_B2ms", 2)
    ];
    return of(envs).pipe(delay(200));
  }

  createQuotation(request: SelfBuyForm) {
    return null
    // return this.http.post(environment.api.routes.subscription.paid.register_self_buy_request, request);
  }

  purchaseQuotation(quotationId: string): Observable<boolean> {
    return of(true).pipe(delay(200));
  }
  
  verifyQuotationOTP(request: QuotationOtp): Observable<boolean> {
    return of(true).pipe(delay(200));
  }
  
  resendQuotatotionOTP(quotationId: string): Observable<string> {
    // const errorDuration = Math.floor(Math.random() * 30) + 1; 
    // return throwError(errorDuration.toString()).pipe(delay(200)); 
    return of("OTP sent successfully!").pipe(delay(200));
  }

  sendQuotationOTP(quotationId: string): Observable<boolean> {
    return of(true).pipe(delay(200));
  }

  getQuotationPriceBreakdown(quotationId: string): Observable<boolean> {
    return of(true).pipe(delay(200));
  }

  getEnvironments(): Observable<ConfigureEnvironment[]> {

    const environments: ConfigureEnvironment[] = [
      { environmentName: "ENV-1", environmentType: "production", cloudVendor: "AWS", operatingSystem: "Windows", cloudRegion: "US East (N. Virginia)", serverProfile: "ENT-4", reservedMachines: 4, unconfiguredMachines: 2, configured: false },
      { environmentName: "ENV-2", environmentType: "staging", cloudVendor: "Azure", operatingSystem: "Linux", cloudRegion: "West Europe (Netherlands)", serverProfile: "ENT-2", reservedMachines: 3, unconfiguredMachines: 1, configured: true },
      { environmentName: "ENV-3", environmentType: "dev", cloudVendor: "AWS", operatingSystem: "Linux", cloudRegion: "Asia Pacific (Singapore)", serverProfile: "ENT-6", reservedMachines: 2, unconfiguredMachines: 0, configured: false },
      { environmentName: "ENV-4", environmentType: "test", cloudVendor: "Azure", operatingSystem: "Windows", cloudRegion: "US Central", serverProfile: "STD-3", reservedMachines: 6, unconfiguredMachines: 3, configured: true },
      { environmentName: "ENV-5", environmentType: "test", cloudVendor: "AWS", operatingSystem: "Linux", cloudRegion: "Canada Central", serverProfile: "ENT-2", reservedMachines: 5, unconfiguredMachines: 1, configured: false },
      { environmentName: "ENV-6", environmentType: "production", cloudVendor: "Azure", operatingSystem: "Linux", cloudRegion: "Australia East (Sydney)", serverProfile: "ENT-8", reservedMachines: 8, unconfiguredMachines: 4, configured: true },
      { environmentName: "ENV-7", environmentType: "staging", cloudVendor: "AWS", operatingSystem: "Windows", cloudRegion: "South America (Brazil)", serverProfile: "ENT-16", reservedMachines: 3, unconfiguredMachines: 1, configured: false },
    ];

    return of(environments).pipe(delay(200));
  }

  getQuotationDetails(subscriptionId:string):Observable<QuotationDetails>{
    return this.http.get(environment.api.routes.quotation.quotation_details,{subscriptionId})
  }

  generateQuotation24x7(data:any){
    return this.http.post(environment.api.routes.quotation.generate_24x7_quotation,data)
  }

  getQuotationByQuotationId(quotationId:string):Observable<QuotationDetails>{
    return this.http.get(environment.api.routes.quotation.quotation_by_quotation_id,{quotationId})
  }

  get24x7QuotationPrice(data:any):Observable<any>{
    return this.http.get(environment.api.routes.quotation.quotation_24_7_price,data)
  }
  getEnvNameMaxLength():Observable<any>{
    return this.http.get(environment.api.routes.quotation.env_name_max_length)
  }

  getQuotationPeriod(subscriptionId:string):Observable<QuotationType>{
    return this.http.get(environment.api.routes.quotation.quotation_perioid,{subscriptionId})
  }

  getQuotationCostWithTwentyFour(data:any):Observable<any>{
    return this.http.post(environment.api.routes.quotation.quotation_cost_24x7,data)
  }

  getNonHostedQuotationById(quotationId:string):Observable<any>{
    return this.http.get(environment.api.routes.quotation.nonhosted_quotation_by_id,{quotationId})
  }
  requestNonHostedQuotation(subscriptionId:string):Observable<any>{
    return this.http.post(environment.api.routes.quotation.generate_nonhosted_quotation_request,{subscriptionId})
  }
  getEnvironmentPricing(data) {
    return this.http.post<QuotationEnvironmentsModel>(environment.api.routes.environment.pricing, data);
  }
  getExistingQuotationEnvironmentNames(subscriptionId:string):Observable<string[]>{
    return this.http.get(environment.api.routes.quotation.quotation_existing_name,{subscriptionId})
  }

  get24x7Cost(){
    return this.http.get<number>(environment.api.routes.quotation.quotation_24x7_cost)
  }
}
